module.exports = __webpack_public_path__ + "387242d1ec7489a6b880943535a45869.jpg";